
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inflow-calculation/introduction",
      function () {
        return require("private-next-pages/inflow-calculation/introduction.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inflow-calculation/introduction"])
      });
    }
  